'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { cx } from '@chakra-ui/utils/cx';
import { StatStylesProvider } from './stat-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const StatRoot = forwardRef(
  function StatRoot2(props, ref) {
    const styles = useMultiStyleConfig("Stat", props);
    const rootProps = omitThemingProps(props);
    return /* @__PURE__ */ jsx(StatStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(
      chakra.div,
      {
        ref,
        ...rootProps,
        className: cx("chakra-stat", rootProps.className),
        __css: styles.root,
        children: /* @__PURE__ */ jsx("dl", { children: rootProps.children })
      }
    ) });
  }
);
StatRoot.displayName = "Stat";

export { StatRoot };
